import cloudflareLoader from "@/lib/cloudflare-images";
import Image from "next/image";

const RecipeSelectionFollowUpStep = ({
  stepData,
  handleContinue,
}: {
  stepData: any;
  handleContinue?: () => void;
}) => {
  const recipe = stepData?.linkedRecipeSelection?.[0];

  if (!recipe) {
    return null;
  }

  const image = stepData?.linkedOptionImages?.[0];

  const userReview = stepData?.userReview?.[0];

  return (
    <div className="space-y-8 px-4 text-left text-black md:text-center">
      {/* Title */}
      <div
        className="font-spatial text-xl font-medium md:text-2xl [&>span]:text-orange-400"
        dangerouslySetInnerHTML={{ __html: stepData.title }}
      />

      {/* Review */}
      {userReview && (
        <div className="space-y-3">
          <div className="flex justify-center gap-1 text-2xl text-spring">
            {[...Array(Number(userReview.rating))].map((_, i) => (
              <span key={i}>★</span>
            ))}
          </div>
          <p
            className="text-balance font-body text-sm font-medium"
            data-posthog="onboarding-recipe-selection-followup-review"
          >
            "{userReview.review}"
          </p>
          {userReview.author && (
            <p
              className="font-body text-xs font-medium"
              data-posthog="onboarding-recipe-selection-followup-author"
            >
              {userReview.author}
            </p>
          )}
        </div>
      )}

      {/* Mobile image */}
      {image?.url && (
        <div className="mt-6 block w-full sm:hidden">
          <div className="relative aspect-[4/3] w-full overflow-hidden">
            <Image
              src={image.url}
              alt={image.title || "Recipe preview"}
              fill
              className="object-cover"
              priority
              loader={cloudflareLoader}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RecipeSelectionFollowUpStep;
